import React, { useState, useEffect } from 'react'
import { Col, Modal, Row, Table } from 'react-bootstrap'
import {
  Button,
  paymentType as paymentTypeConst,
  // paymentStatusLabel,
} from '@abroad/components'
import { useParams } from 'react-router-dom'
import { formatDateForDisplay } from '../../utils/date'
import { getConditionalSessionLabel } from './schedulingHelpers'
// import Labels from '../../constants/labels'

const CoachingPlanDetailsModal = ({
  values,
  showModal,
  setShowModal,
  handleSubmit,
  isLoading,
  isBulkAssignSOWSection = false,
}) => {
  const { planId } = useParams()
  const [readyPayButton, setReadyPayButton] = useState(false)
  const [readyPayInfoPopup, setReadyPayInfoPopup] = useState(
    planId === 'create' || isBulkAssignSOWSection ? false : true,
  )
  // const { values } = useFormikContext()
  useEffect(() => {
    if (showModal) {
      if (planId === 'create' || isBulkAssignSOWSection) {
        setReadyPayInfoPopup(false)
      } else {
        setReadyPayInfoPopup(true)
      }
    }
  }, [planId, showModal, isBulkAssignSOWSection])

  if (values && Object.keys(values).length === 0) return null

  const tableHeaderClasses = 's6'

  const renderTable = () => {
    return (
      <Table hover className='custom-table'>
        <tbody className='overflow-y'>
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Name:
            </th>
            <td width='50%'>{values?.planName}</td>
          </tr>
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              SOW Type:
            </th>
            <td width='50%'>
              {values?.sowType === 'QUEST' ? 'Experience' : 'REGULAR'}
            </td>
          </tr>
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Scheduling Type:
            </th>
            <td width='50%'>
              {values?.isPlatformScheduling === false ||
              values?.isPlatformScheduling === 'false'
                ? 'Manual Scheduling'
                : values?.isPlatformScheduling === true ||
                  values?.isPlatformScheduling === 'true'
                ? 'Platform Scheduling'
                : 'Platform Scheduling'}
            </td>
          </tr>
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Include Bio in the Schedule Email?:
            </th>
            <td width='50%'>
              {values?.includeBioInMail === true ? 'Yes' : 'No'}
            </td>
          </tr>
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Payment Required?:
            </th>
            <td width='50%'>
              {values?.isPaymentRequired === 'true' ? 'Yes' : 'No'}
            </td>
          </tr>
          <>
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                Payment Cycle:
              </th>
              <td width='50%'>
                {values?.paymentCycle === paymentTypeConst.ONETIME
                  ? 'One Time'
                  : 'Recurring'}
              </td>
            </tr>
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                {values?.paymentCycle === paymentTypeConst.RECURRING
                  ? 'Upfront/Setup Fee (USD)'
                  : 'One Time Fee (USD)'}
                :
              </th>
              <td width='50%'>
                {values?.paymentCycle === paymentTypeConst.RECURRING
                  ? values?.upfrontFee
                  : values?.onetimeAmount}
              </td>
            </tr>
            {values?.paymentCycle === paymentTypeConst.RECURRING && (
              <>
                <tr>
                  <th width='50%' className={tableHeaderClasses}>
                    Bill Every (Month(s)):
                  </th>
                  <td width='50%'>{values?.invoiceEvery}</td>
                </tr>
                <tr>
                  <th width='50%' className={tableHeaderClasses}>
                    Subscription Amount (USD):
                  </th>
                  <td width='50%'>{values?.subscriptionAmount}</td>
                </tr>

                <tr>
                  <th width='50%' className={tableHeaderClasses}>
                    Number Of Billing Cycle:
                  </th>
                  <td width='50%'>
                    {values?.numberOfBillingCycle || 'Indifinite'}
                  </td>
                </tr>
              </>
            )}
          </>
          {(values?.paymentCycle === paymentTypeConst.ONETIME ||
            (values?.invoiceEvery && values?.numberOfBillingCycle)) && (
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                Total Duration Of Contract
              </th>
              <td width='50%'>
                {values?.totalDurationOfContract || 'Indifinite'}
              </td>
            </tr>
          )}
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Number of sessions:
            </th>
            <td width='50%'>
              {values?.sessionPerCoachingCycle} per {values?.numberOfMonths}{' '}
              {values.typeOfCoachingCycle === 'Weekly'
                ? 'Week(s)'
                : values.typeOfCoachingCycle === 'Yearly'
                ? 'Years(s)'
                : 'Month(s)'}
            </td>
          </tr>
          {values?.includeGrowthSession && (
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                Include Growth Session
              </th>
              <td width='50%'>Yes</td>
            </tr>
          )}
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Regular Session Duration:
            </th>
            <td width='50%'>{values?.sessionDuration}</td>
          </tr>
          {values?.isConditionalSchedulingEnabled && (
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                Conditional Scheduling:
              </th>
              <td width='50%'>
                {values?.isConditionalSchedulingEnabled ? 'Yes' : 'No'}
              </td>
            </tr>
          )}
          {values?.includeGrowthSession && (
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                Growth Session Duration:
              </th>
              <td width='50%'>{values?.growthSessionDuration}</td>
            </tr>
          )}
          {(values.numberOfBillingCycle || values.totalDurationOfContract) && (
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                Total Session:
              </th>
              <td width='50%'>{values?.totalSession}</td>
            </tr>
          )}
          {/* <tr>
            <th width='50%' className={tableHeaderClasses}>
              360 Report:
            </th>
            <td width='50%'>{values?.report360 ? 'Yes' : 'No'}</td>
          </tr> */}
          {/* {values?.report360 && (
            <React.Fragment>
              <tr>
                <th width='50%' className={tableHeaderClasses}>
                  360 Report Plan:
                </th>
                <td width='50%'>
                  {
                    Labels.ReportPlanOf360.find(
                      (e) => e.key === parseInt(values?.reportPlan360),
                    )?.value
                  }
                </td>
              </tr>
               <tr>
                <th width='50%' className={tableHeaderClasses}>
                  360 Report Hourly Rate:
                </th>
                <td width='50%'>{values?.report360hourlyRate}</td>
              </tr> 
            </React.Fragment>
          )} */}
          {/* <tr>
            <th width='50%' className={tableHeaderClasses}>
              Impact Report:
            </th>
            <td width='50%'>{values?.impactReport ? 'Yes' : 'No'}</td>
          </tr> */}
          {/* {values?.impactReport && (
            <React.Fragment>
              <tr>
                <th width='50%' className={tableHeaderClasses}>
                  Impact Report Plan:
                </th>
                <td width='50%'>
                  {
                    Labels.impactReportPlan.find(
                      (e) => e.key === parseInt(values?.impactReportPlan),
                    )?.value
                  }
                </td>
              </tr>
              <tr>
                <th width='50%' className={tableHeaderClasses}>
                  Impact Report Hourly Rate:
                </th>
                <td width='50%'>{values?.impactReporthourlyRate}</td>
              </tr>
            </React.Fragment>
          )} */}
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Regular Rate Paid To Coach (USD):
            </th>
            <td width='50%'>
              {values?.coachingRate}/
              {values?.coachingRateType === 'hourly' ? 'Hour' : 'Session'}
            </td>
          </tr>
          {values?.includeGrowthSession && (
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                Growth Rate Paid To Coach (USD):
              </th>
              <td width='50%'>
                {values?.growthCoachingRate}/
                {values?.growthCoachingRateType === 'hourly'
                  ? 'Hour'
                  : 'Session'}
              </td>
            </tr>
          )}
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Client Time Zone:
            </th>
            <td width='50%'>{values?.clientTimeZone}</td>
          </tr>
          <tr>
            <th width='50%' className={tableHeaderClasses}>
              Date Of First Paid Session:
            </th>
            <td width='50%'>{values?.planStartDate}</td>
          </tr>
          {values?.sowType === 'QUEST' && values?.questName && (
            <tr>
              <th width='50%' className={tableHeaderClasses}>
                Experience:
              </th>
              <td width='50%'>{values?.questName}</td>
            </tr>
          )}
          {values?.totalSession &&
            Number(values.totalSession) <= 3 &&
            values?.isConditionalSchedulingEnabled &&
            values?.schedulingConditions &&
            Array.isArray(values.schedulingConditions) &&
            values.schedulingConditions.length > 0 && (
              <tr>
                <th width='50%' className={tableHeaderClasses}>
                  Conditional Scheduling:
                </th>
                <td width='50%'>
                  <div className='d-flex flex-column'>
                    {values.schedulingConditions.map((condition, index) => {
                      if (!condition || !condition.condition) return null

                      const sessionNum = condition.sessionIndex || index + 1
                      const sessionLabel = getConditionalSessionLabel(
                        sessionNum,
                        values?.sowType,
                      )
                      let conditionText = ''

                      const formattedPrimaryDate = formatDateForDisplay(
                        condition.primaryDate,
                      )
                      const formattedSecondaryDate = formatDateForDisplay(
                        condition.secondaryDate,
                      )

                      if (condition.condition === 'between') {
                        conditionText = `${sessionLabel}: Between ${formattedPrimaryDate} and ${formattedSecondaryDate}`
                      } else if (condition.condition === 'on_or_before') {
                        conditionText = `${sessionLabel}: On or Before ${formattedPrimaryDate}`
                      } else if (condition.condition === 'on_or_after') {
                        conditionText = `${sessionLabel}: On or After ${formattedPrimaryDate}`
                      }

                      return conditionText ? (
                        <div key={index} className='mb-1'>
                          {conditionText}
                        </div>
                      ) : null
                    })}
                  </div>
                </td>
              </tr>
            )}
        </tbody>
      </Table>
    )
  }

  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(true)
      }}
      size='lg'
      scrollable={true}
      className='sow-modal custom__modal'
      centered>
      <Modal.Header>
        <h3 className='s3 mb-0'>
          {readyPayInfoPopup
            ? 'Send for payment?'
            : ' Once plan is saved, you can not edit it apart from timezone and status.'}
        </h3>
      </Modal.Header>
      <Modal.Body className='pt-point-5 pb-point-5'>
        <Row className='save-sow-table'>
          <Col>
            {readyPayInfoPopup
              ? 'Once you click send, we will send an email to the client with a payment link.'
              : renderTable()}
          </Col>
        </Row>
      </Modal.Body>
      {readyPayInfoPopup ? (
        <>
          <Modal.Footer>
            {!isLoading && (
              <Button
                variant='none'
                className='text-uppercase line-height-normal secondary-popup-button'
                isLoading={isLoading}
                disabled={isLoading}
                onClick={() => {
                  handleSubmit({ ...values, isReadyForPayment: false })
                  setShowModal(false)
                }}>
                Save As Draft
              </Button>
            )}
            <Button
              variant='saffron'
              className='text-uppercase line-height-normal'
              onClick={() => {
                handleSubmit({ ...values, isReadyForPayment: true })
                setShowModal(false)
              }}
              isLoading={isLoading}
              disabled={isLoading}>
              Send
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <>
          <Modal.Footer>
            {!readyPayButton && (
              <>
                <Button
                  variant='none'
                  className='text-uppercase line-height-normal secondary-popup-button'
                  onClick={() => setShowModal(false)}>
                  Re-edit
                </Button>
                <Button
                  variant='saffron'
                  className='text-uppercase line-height-normal'
                  onClick={() => {
                    if (values?.isPaymentRequired === 'false') {
                      handleSubmit(values)
                      setShowModal(false)
                    } else {
                      setReadyPayButton(true)
                    }
                  }}
                  isLoading={isLoading}
                  disabled={isLoading}>
                  Save
                </Button>
              </>
            )}
            {readyPayButton && (
              <>
                {!isLoading && (
                  <Button
                    variant='none'
                    className='text-uppercase line-height-normal secondary-popup-button'
                    onClick={() => {
                      handleSubmit({ ...values, isReadyForPayment: false })
                      setShowModal(false)
                    }}
                    isLoading={isLoading}
                    disabled={isLoading}>
                    Save As Draft
                  </Button>
                )}
                <Button
                  variant='saffron'
                  className='text-uppercase line-height-normal'
                  onClick={() => {
                    if (planId === 'create' || isBulkAssignSOWSection) {
                      setReadyPayInfoPopup(true)
                    } else {
                      handleSubmit({
                        ...values,
                        isReadyForPayment: true,
                      })
                      setShowModal(false)
                    }
                  }}
                  isLoading={isLoading}
                  disabled={isLoading}>
                  Send for Payment?
                </Button>
              </>
            )}
          </Modal.Footer>
        </>
      )}
    </Modal>
  )
}

export default CoachingPlanDetailsModal
